import { render, staticRenderFns } from "./newproduct-process.vue?vue&type=template&id=382c2dc1&scoped=true&"
import script from "./newproduct-process.vue?vue&type=script&lang=js&"
export * from "./newproduct-process.vue?vue&type=script&lang=js&"
import style0 from "./newproduct-process.vue?vue&type=style&index=0&id=382c2dc1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c2dc1",
  null
  
)

export default component.exports